/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from 'react'
import { modalEnum, TableController } from '../../../components/Constant'
import { GET_VENDOR_REPORT } from '../../../repository/revenue_reports_repo'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import useReduxStore from '../../../hooks/useReduxStore'
import { LOCATION_LIST } from '../../../repository/vendor_management_repo'
import { useLocation } from 'react-router-dom'
import { reportKeyMap } from '../constant'

export default function useReports() {
  const [loader, setLoader] = useState(false)
  const [controller, setController] = useState(TableController)
  const [resetAction, setResetAction] = useState(false)
  const [filterModal, setFilterModal] = useState(modalEnum)
  const [locationList, setLocationList] = useState([])
  const [details, setDetails] = useState([])
  const [activeIndex, setActiveIndex] = useState(0)
  const [totalCount, setTotalCount] = useState(0)
  const [activeBookingIndex, setActiveBookingIndex] = useState(0)
  const { t } = useTranslation()
  const location = useLocation()
  const [filter, setFilter] = useState({
    search: '',
    filter: 'THIS_MONTH',
    startDate: null,
    endDate: null,
    location: [],
  })
  const { selector: user } = useReduxStore('auth')
  const BookingTableHead = [
    { label: `${t('tableTitle.image')}` },
    { label: `${t('tableTitle.bookingNumber')}` },
    { label: `${t('tableTitle.user')}` },
    { label: `${t('tableTitle.BookingDate')}` },
    { label: `${t('tableTitle.service')}` },
    { label: `${t('formTitle.totalAmount')}` },
    { label: `${t('tableTitle.amountToReceive')}` },
    { label: `${t('tableTitle.receivedByAdmin')}` },
    { label: `${t('tableTitle.amountToBePaid')}` },
    { label: `${t('boxTitle.booking')} ${t('formTitle.location')}` },
    { label: `${t('boxTitle.vendor')} ${t('formTitle.location')}` },
    { label: `${t('tableTitle.extraCharges')}` },
    { label: `${t('boxTitle.refund')}  ${t('boxTitle.amount')}` },
  ]
  const paymentCommissionTableHead = [
    // { label: `${t("tableTitle.image")}` },
    { label: `${t('tableTitle.bookingNumber')}` },
    { label: `${t('tableTitle.user')}` },
    { label: `${t('tableTitle.BookingDate')}` },
    { label: `${t('tableTitle.service')}` },
    { label: `${t('formTitle.totalAmount')}` },
    { label: `${t('tableTitle.amountToReceive')}` },
    { label: `${t('tableTitle.settled')}` },
    { label: `${t('tableTitle.unsettled')}` },
    { label: `${t('tableTitle.commissionCharges')}` },
    { label: `${t('boxTitle.booking')} ${t('formTitle.location')}` },
    { label: `${t('boxTitle.vendor')} ${t('formTitle.location')}` },
    { label: `${t('tableTitle.extraCharges')}` },
  ]

  const cancelledTableHead = [
    { label: `${t('tableTitle.bookingNumber')}` },
    { label: `${t('tableTitle.user')}` },
    { label: `${t('buttonTitle.cancel')} ${t('tableTitle.date')}` },
    { label: `${t('buttonTitle.cancel')} ${t('filterTitle.reason')}` },
    { label: `${t('tableTitle.service')}` },
    { label: `${t('boxTitle.amount')}` },
  ]
  const completedTableHead = [
    { label: `${t('tableTitle.image')}` },
    { label: `${t('tableTitle.bookingNumber')}` },
    { label: `${t('tableTitle.user')}` },
    { label: `${t('tableTitle.service')}` },
    { label: `${t('tableTitle.quantity')}` },
    { label: `${t('tableTitle.finalPrice')}` },
  ]
  const paymentRefundTableHead = [
    { label: `${t('tableTitle.bookingNumber')}` },
    { label: `${t('tableTitle.user')}` },
    { label: `${t('boxTitle.refund')} ${t('tableTitle.date')}` },
    { label: `${t('tableTitle.remark')}` },
    { label: `${t('boxTitle.amount')}` },
  ]
  const paymentReceivedTableHead = [
    { label: `${t('tableTitle.bookingNumber')}` },
    { label: `${t('tableTitle.date')}` },
    { label: `${t('tableTitle.remark')}` },
    { label: `${t('boxTitle.payment')} ${t('tableTitle.type')}` },
    { label: `${t('boxTitle.amount')}` },
  ]
  const filterOptions = [
    { value: 'THIS_MONTH', label: t('optionTitle.thisMonth') },
    { value: 'LAST_MONTH', label: t('optionTitle.lastMonth') },
    { value: 'LAST3_MONTH', label: t('optionTitle.last3Month') },
    { value: 'LAST6_MONTH', label: t('optionTitle.last6Month') },
    { value: 'THIS_YEAR', label: t('optionTitle.thisYear') },
    { value: 'CUSTOM', label: t('optionTitle.custom') },
  ]
  function reportKey() {
    const pathSegments = location.pathname.split('/').filter(Boolean)
    const lastSegment = pathSegments[pathSegments.length - 1]?.toLowerCase()
    return reportKeyMap[lastSegment] || null
  }
  const onBookingPieEnter = useCallback(
    (_, index) => {
      setActiveBookingIndex(index)
    },
    [setActiveBookingIndex]
  )

  const onPieEnter = useCallback(
    (_, index) => {
      setActiveIndex(index)
    },
    [setActiveIndex]
  )

  async function getLocationList() {
    setLoader(true)
    const payload = {
      vendor_id: user?.userInfo?._id,
      isDeleted: false,
      isActive: true,
      page: 1,
      count: 10000,
    }
    try {
      let response = await LOCATION_LIST(payload)
      let data = response?.data?.map((cur) => ({ ...cur, locationName: `${cur?.city ?? ''} , ${cur?.state ?? ''} , ${cur?.country ?? ''}` }))
      setLocationList(data)
      setLoader(false)
    } catch (error) {
      setLocationList([])
      setLoader(false)
    }
  }
  async function getReportsDetails() {
    const { page, rowsPerPage } = controller
    setLoader(true)
    const payload = {
      type: reportKey() === 'BOOKING' ? 'COMMISSION' : reportKey(),
      page: page,
      count: rowsPerPage,
    }
    try {
      let response = await GET_VENDOR_REPORT(payload)
      setDetails(response?.data)
      setTotalCount(response?.totalCount)
      setLoader(false)
    } catch (error) {
      setDetails([])
      toast.error(error?.message)
      setLoader(false)
      setTotalCount(0)
    }
  }
  const handleChangeFilter = ({ target: { name, value } }) => {
    setFilter((prev) => ({
      ...prev,
      [name]: value,
      ...(value === 'CUSTOM' && { startDate: null, endDate: null }),
    }))
  }

  const reset = () => {
    setFilterModal({ data: {}, open: false })
    setFilter((prev) => ({
      ...prev,
      search: '',
      filter: 'THIS_MONTH',
      startDate: null,
      endDate: null,
      location: [],
    }))
    setResetAction((prev) => !prev)
  }

  const handleApply = async () => {
    if (filter?.filter === 'CUSTOM') {
      if (!filter.startDate || !filter.endDate) {
        toast(t('validation.customfilterStartDateEndDate'))
        return
      }
      if (new Date(filter.startDate) > new Date(filter.endDate)) {
        toast(t('validation.greaterThanEndDate'))
        return
      }
    }
    await getReportsDetails()
    setFilterModal({ data: {}, open: false })
  }

  useEffect(() => {
    if (false === true) {
      // not used
      getLocationList()
    }
  }, [])

  const handlePagination = (obj) => {
    setController(obj)
  }

  useEffect(() => {
    getReportsDetails()
  }, [resetAction, controller])

  return {
    filterModal,
    BookingTableHead: paymentCommissionTableHead,
    activeIndex,
    filter,
    activeBookingIndex,
    locationList,
    filterOptions,
    details,
    loader,
    controller,
    totalCount,
    paymentCommissionTableHead,
    cancelledTableHead,
    completedTableHead,
    paymentRefundTableHead,
    paymentReceivedTableHead,
    setFilterModal,
    onPieEnter,
    onBookingPieEnter,
    handleChangeFilter,
    handleApply,
    reset,
    handlePagination,
  }
}
